import React from 'react';

import App from '@app/App';
import { queryClient } from '@app/queryClient';
import { startAnalytics } from '@app/services/analytics.service';
import { store } from '@app/store/store';
import { QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './i18n';

// Before the first render, so no component's mount-time event can race the boot.
startAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
	<Provider store={store}>
		<QueryClientProvider client={queryClient}>
			<App />
		</QueryClientProvider>
	</Provider>,
);
